<template>
  <VueJsModalPrimary
    v-bind="{ ...attrs.modal, ...$attrs }"
    v-on="$listeners"
    @before-open="beforeOpen"
  >
    <div :style="style.container">
      <HeaderLargePrimary>
        Rename survey
      </HeaderLargePrimary>
      <InputPrimary
        v-model="input"
        placeholder="Enter survey name"
      />
      <div :style="style.buttons">
        <ButtonSecondary @click="close">
          Cancel
        </ButtonSecondary>
        <ButtonPrimary
          :disabled="disableUpdate"
          @click="$emit('rename-survey', renamedSurvey)"
        >
          Save
        </ButtonPrimary>
      </div>
    </div>
  </VueJsModalPrimary>
</template>

<script>
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import ButtonSecondary from '@modules/v2/button/button-secondary'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import InputPrimary from '@modules/v2/input/input-primary'
  import VueJsModalPrimary from '@modules/v2/modal/vue-js-modal-primary'
  import { Layout } from '@js/styles'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'ModalSurveyRenamePrimary',
    inheritAttrs: false,
    components: {
      ButtonPrimary,
      ButtonSecondary,
      HeaderLargePrimary,
      InputPrimary,
      VueJsModalPrimary,
    },
    data: function () {
      return {
        initInput: '',
        input: '',
        name: MODAL_WINDOW_NAMES.RENAME_SURVEY_PRIMARY,
        survey: {},
        attrs: {
          modal: {
            height: '240px',
            maxWidth: 480,
            maxHeight: 240,
            minHeight: 240,
          },
        },
        style: {
          buttons: {
            alignItems: 'flex-end',
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          },
          container: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
            padding: Layout.space.lg,
            width: '100%',
          },
        },
      };
    },
    created: function () {
      this.attrs.modal.name = this.name;
    },
    computed: {
      disableUpdate: function () {
        return (
          this.initInput === this.input ||
          this.input.trim().length === 0
        );
      },
      renamedSurvey: function () {
        return {
          ...this.survey,
          name: this.input,
        };
      },
    },
    methods: {
      beforeOpen: function (e) {
        this.clearCache();
        if (
          e.params?.survey === undefined ||
          e.params?.survey === null
        ) {
          this.$store.commit(
            'notification/setWarning',
            'Failed to parse survey',
          );
          this.$modal.hide(this.name);
        }
        this.survey = e.params.survey;
        this.initInput = this.survey.name;
        this.input = this.initInput;
      },
      clearCache: function () {
        this.initInput = '';
        this.input = '';
        this.survey = {};
      },
      close: function () {
        this.clearCache();
        this.$modal.hide(this.name);
      },
    },
  };
</script>
